import React from 'react';
import './Other.scss';

class Other extends React.Component {
    // constructor (props) {
    //   super(props);
    //   this.state = {
  
    //   }
    // }
    render() {
        return (
            <div className="Other">
                404 not found and bad smile
            </div>
        )
    }   
}

export default Other;